// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2i4wZ","fileBtn":"File_fileBtn__2Mdcu","closeBtn":"File_closeBtn__1ri8m","fileSelected":"File_fileSelected__364lA","disabled":"File_disabled__1MTR0"};